import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from '@mui/material';
import { useUpdatePropertyMutation } from '../store/docApi';
import { Add } from '@mui/icons-material';
import ColorwayCard from './ColorwayCard';
import { generateEntityId, objectToArray } from '../utils';

export default function Colorways({ item }) {
  const navigate = useNavigate();
  const [updateProperty] = useUpdatePropertyMutation();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [newColorway, setNewColorway] = useState({ id: generateEntityId('colorway'), name: '', chromas: [] });

  const addColorway = () => {
    updateProperty({ label: item.label, pk: item.pk, id: item.id, name: `colorways/${newColorway.id}`, value: newColorway });
    setNewColorway({ id: generateEntityId('colorway'), name: '', chromas: [] });
    setIsDialogOpen(false);
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Colorways
      </Typography>
      <Box
        sx={{
          display: 'grid',
          gap: 2,
          gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))'
        }}
      >
        {item.colorways &&
          objectToArray(item.colorways).map((colorway) => (
            <ColorwayCard key={colorway.id} colorway={colorway} onClick={() => navigate(`/workspaces/${item.pk}/${item.id}/colorways/${colorway.id}`)} />
          ))}
      </Box>
      <Button variant="outlined" startIcon={<Add />} onClick={() => setIsDialogOpen(true)} sx={{ mt: 2 }}>
        Add Colorway
      </Button>
      <Dialog open={isDialogOpen} onClose={() => setIsDialogOpen(false)} fullWidth>
        <DialogTitle>Add New Colorway</DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ mb: 1 }}>
            ID
          </Typography>
          <TextField
            value={newColorway.id}
            onChange={(e) => setNewColorway({ ...newColorway, id: e.target.value })}
            fullWidth
            size="small"
            sx={{ mb: 2 }}
          />
          <TextField
            label="Name"
            value={newColorway.name}
            onChange={(e) => setNewColorway({ ...newColorway, name: e.target.value })}
            fullWidth
            size="small"
            sx={{ mb: 2 }}
          />
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" onClick={() => setIsDialogOpen(false)}>
            Cancel
          </Button>
          <Button variant="contained" onClick={addColorway}>
            Add
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
